import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import './brand.css';
import './game-display.css';
import './creative-display.css';
import './player-identity.css';
import App from './App';
import { GameProvider } from './components/GameContext';
import reportWebVitals from './reportWebVitals';

(window.RecessBoot || Promise.resolve()).then(() => ReactDOM.render(
  <BrowserRouter>
    <React.StrictMode>
      <GameProvider>
        <App />
      </GameProvider>
    </React.StrictMode>
  </BrowserRouter>,
  document.getElementById('root')
));

reportWebVitals();
